var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLogoTb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TB_Icon",
    "data-name": "TB Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_260px",
    "data-name": "260px",
    transform: "translate(5.6 7.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M36.922,41.912a3.717,3.717,0,0,1-2.534-.715,3.018,3.018,0,0,1-.793-2.341V34.589H32.508V32.606H33.6V30.414l2.841-1v3.187h2.746v1.983H36.437v3.239q0,.481.008.839a1.715,1.715,0,0,0,.131.643.9.9,0,0,0,.4.451,1.706,1.706,0,0,0,.843.167,2.559,2.559,0,0,0,.6-.094,2.517,2.517,0,0,0,.517-.173h.245v1.993a8.15,8.15,0,0,1-.984.189A10.092,10.092,0,0,1,36.922,41.912Z",
    transform: "translate(-32.508 -29.419)",
    fill: "#002b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(7.837 0.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M53.227,37.073a5.359,5.359,0,0,1-1.109,3.522,3.423,3.423,0,0,1-2.747,1.344,4.2,4.2,0,0,1-1.19-.15,5.2,5.2,0,0,1-1.076-.476l-.122.455H44.264V30.5l2.841-1v4.089a6.566,6.566,0,0,1,1.279-.87,3.272,3.272,0,0,1,1.509-.333,2.827,2.827,0,0,1,2.465,1.243A5.937,5.937,0,0,1,53.227,37.073Zm-2.917.059a3.464,3.464,0,0,0-.416-1.949,1.466,1.466,0,0,0-1.28-.585,2.474,2.474,0,0,0-.762.122,2.994,2.994,0,0,0-.746.365v4.581a2.475,2.475,0,0,0,.575.155,4.1,4.1,0,0,0,.575.04,1.8,1.8,0,0,0,1.545-.682A3.4,3.4,0,0,0,50.309,37.131Z",
    transform: "translate(-44.264 -29.5)",
    fill: "#ee3424"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogoTb);
export default __webpack_public_path__ + "static/media/ico-logo-tb.5f9feef424712cba8420d66146df0de0.svg";
export { ForwardRef as ReactComponent };